import React from 'react';
import { Layout } from '../components/Layout';

export function Privacy() {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8">Privacy Policy</h1>
        <div className="prose prose-lg max-w-none space-y-6">
          <p className="text-gray-600 text-sm">Last Updated: December 1, 2024</p>
          
          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">1. Information We Collect</h2>
            <p>
              We collect information you provide directly to us, including:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Account Information:</strong> Email address, name, password</li>
              <li><strong>Content:</strong> Documents, text, and creative works you create</li>
              <li><strong>Payment Information:</strong> Processed securely through Stripe (we don't store card details)</li>
              <li><strong>Usage Data:</strong> How you interact with our Service</li>
              <li><strong>Device Information:</strong> Browser type, IP address, device identifiers</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">2. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Provide, maintain, and improve our Service</li>
              <li>Process your payments and fulfill service requests</li>
              <li>Send you technical notices and support messages</li>
              <li>Respond to your comments and questions</li>
              <li>Analyze usage patterns and optimize performance</li>
              <li>Detect and prevent fraud and abuse</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">3. AI and Your Content</h2>
            <p>
              <strong>Your content is private:</strong> We do not use your documents or creative works to train AI models or share them with third parties, except as necessary to provide our Service (e.g., processing through AI APIs).
            </p>
            <p className="mt-4">
              <strong>AI Processing:</strong> When you use AI features, your content is sent to third-party AI providers (OpenAI, Anthropic, Google) solely for processing your request. These providers have their own privacy policies.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">4. Data Sharing and Disclosure</h2>
            <p>We may share your information with:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Service Providers:</strong> Stripe for payments, AI providers for text generation</li>
              <li><strong>Legal Requirements:</strong> If required by law or to protect our rights</li>
              <li><strong>Business Transfers:</strong> In connection with a merger or acquisition</li>
            </ul>
            <p className="mt-4">
              <strong>We do not sell your personal information to third parties.</strong>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">5. Data Security</h2>
            <p>
              We implement industry-standard security measures to protect your data:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Encryption in transit (HTTPS/TLS)</li>
              <li>Encrypted database storage</li>
              <li>Secure authentication with bcrypt password hashing</li>
              <li>Regular security audits and updates</li>
              <li>Limited employee access to user data</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">6. Your Rights and Choices</h2>
            <p>You have the right to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Access:</strong> Request a copy of your personal information</li>
              <li><strong>Correction:</strong> Update or correct your information</li>
              <li><strong>Deletion:</strong> Request deletion of your account and data</li>
              <li><strong>Export:</strong> Download your documents and content</li>
              <li><strong>Opt-out:</strong> Unsubscribe from marketing emails</li>
            </ul>
            <p className="mt-4">
              To exercise these rights, contact us at privacy@upost.com
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">7. Data Retention</h2>
            <p>
              We retain your information as long as your account is active or as needed to provide services. After account deletion, we may retain certain information for legal compliance and fraud prevention.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">8. Cookies and Tracking</h2>
            <p>
              We use cookies and similar technologies for:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Authentication and security</li>
              <li>Preferences and settings</li>
              <li>Analytics and performance monitoring</li>
            </ul>
            <p className="mt-4">
              You can control cookies through your browser settings. See our Cookie Policy for more details.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">9. International Users</h2>
            <p>
              If you access our Service from outside the United States, your information may be transferred to and processed in the United States, where data protection laws may differ from your country.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">10. Children's Privacy</h2>
            <p>
              Our Service is not directed to children under 13. We do not knowingly collect personal information from children under 13. If you believe we have collected such information, please contact us immediately.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">11. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of material changes via email or through the Service. Your continued use after changes constitutes acceptance.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">12. Contact Us</h2>
            <p>
              For questions about this Privacy Policy or our data practices:<br />
              <strong>Email:</strong> lscala@upost.com<br />
              <strong>Phone:</strong> (817) 320-5334<br />
              <strong>Mail:</strong> UPost.com, Arlington, TX
            </p>
          </section>
        </div>
      </div>
    </Layout>
  );
}
